<script setup>

import { reverseGradient } from '@/util/FormatStyles.js';

const props = defineProps({
  word: String,
  index: Number,
  answers: Boolean,
  totalTime: Number,
  timeLeft: Number,
  hint: String,
  type: String,
  magnify: Number,
  format: Object,
});

function showLetter(letterKey) {
  let toReturn = false;
  const letter = props.word[letterKey];
  const alwaysShow = [
    ' ',
    ',',
    '\'',
    '.',
    '!',
    '?',
    '(',
    ')',
    '-',
    '*',
    '+',
    '÷',
    '='
  ];
  if (alwaysShow.indexOf(letter) > -1) toReturn = true;
  if (props.answers) toReturn = true;
  if (!props.answers && props.hint === 'none') toReturn = false;
  if (props.hint === 'all') toReturn = true;
  if (props.hint !== 'all') {
    const hints = props.hint ? props.hint.split(',').map(Number) : [];
    if (hints.indexOf(letterKey) > -1) {
      toReturn = true;
    }
  }
  if (props.type === 'wordLeap') {
    if (letterKey === 0) toReturn = true;
  }
  return toReturn;
}

function containerClass(letter, letterkey) {
  let toReturn = 'word-leap__letter-container';
  if (showLetter(letterkey)) {
    if (letter !== ' ') {
      toReturn += ' word-leap__letter-container';
    } else {
      toReturn += ' word-leap__space';
    }
  }
  return toReturn;
}

</script>

<template>
  <div class="word-leap"
    :style="{ background: `${reverseGradient(props.format.background)}`}">
    <div
        v-for="(letter, letterkey) in word"
        :key="letterkey"
        :class="containerClass(letter, letterkey)"
        :style="{ width: `${props.magnify}em`, height: `${props.magnify}em`}">
      <span
          v-if="showLetter(letterkey)"
          v-text="letter.toUpperCase()"
          class="word-leap__letter"
          :style="{ fontSize: props.magnify * 1.25 + 'em' }"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.word-leap {
  display: flex;
  flex-direction: row;
  transition: all 2.2s ease-in;
  &:first-of-type {
    color: black;
  }
  &:last-of-type {
    color: black;
  }
  &__letter-container {
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    border: 1px solid darkslategrey;
    border-radius: 10px;
    color: black;
    background: linear-gradient(to bottom right, #ffd700, #ffcc00, #ffdb58, #ffe58f);
    transition: all 2.2s ease-in;
    margin: 15px 5px;
    &:first-of-type {
      margin-left: auto;
    }
    &:last-of-type {
      margin-right: auto;
    }
  }
  &__letter {
    font-family: 'Courier', sans-serif;
    font-size: 95px;
    font-weight: 800;
    line-height: 60px;
    margin: 0; /* Remove margin to ensure proper centering */
    background: none;
    background-color: none;
    border: none;
  }
  &__blank {
    background: cornflowerblue;
    color: cornflowerblue;
  }
  &__space {
    background: none;
    border: none;
  }
}

.fade-enter-active {
  transition: all 1.75s ease-out;
}

.fade-leave-active {
  transition: all .25s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
